exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.v-input--radio-group.no-message .v-messages {\n  display: none;\n}\n.v-input--radio-group.no-message .v-input__slot {\n  margin-bottom: 0;\n}\n.customRadioBtn.accent--text label {\n  background-color: #2D8732;\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/components/AdditionalOption.vue?vue&type=style&index=1&lang=scss&
// module id = rpJ0
// module chunks = 3